module.exports = __webpack_public_path__ + "static/img/mechanism-3.93f951b3.png";